import { API_URL } from './config';

export async function submitTraceReport(payload) {
  const reportUrl = API_URL.replace('AiAssistantv5.php', 'TraceReporter.php');
  const response = await fetch(reportUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      trace_id: payload.traceId,
      title: payload.title,
      reason: payload.reason
    })
  });

  let result = null;
  try {
    result = await response.json();
  } catch (error) {
    throw new Error('Invalid report response');
  }

  if (!response.ok || !result || result.code !== 200) {
    throw new Error(result && result.message ? result.message : `HTTP ${response.status}`);
  }

  return result;
}
